import { History } from 'history'
import NewRelicUtils from 'src/config/monitoring/NewRelicUtils'
import { TypesRoutes } from 'src/routes/mixedRoutes/types'
import { put } from 'typed-redux-saga'

import { ErrorActions } from '../error/actions'
import { ErrorDetails } from '../error/types'
import { LoadingActions } from '../loading/actions'

export interface SagaWithHistory {
  history?: History
  pathname?: string
  goBack?: boolean
}

/**
 * Realiza o redirecionamento utilizando o useHistory recebido por parâmetro.
 * @param payload Payload recebido através da action.
 */
export function redirectThroughSaga(payload: SagaWithHistory): void {
  if (payload && payload.history && (payload.pathname || payload.goBack)) {
    const { history } = payload

    if (payload.goBack) {
      history.goBack()
    } else if (payload?.pathname) {
      history.push(payload.pathname)
    }
  }
}

/**
 * Tratativa de erro a ser realizada no Saga.
 */
export function* errorHandlingSaga(
  error: Error,
  errorCodeRef: string,
  errorDetails?: ErrorDetails,
  restart?: boolean,
) {
  NewRelicUtils.noticeError(error, { errorCodeRef })

  if (errorDetails === undefined) {
    errorDetails = {
      title: 'Houve um erro por aqui',
      subTitle:
        'Esse serviço está temporariamente indisponível. Você pode tentar novamente mais tarde.',
      disabledButton: false,
      route: restart ? TypesRoutes.START : undefined,
    }
  }

  yield* put(ErrorActions.show(errorDetails))

  yield* put(LoadingActions.hide())
}
